import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {TOKEN_KEY, UserTokenService} from './user-service/user-token.service';
import {catchError, tap, timeout} from 'rxjs/operators';
import {LoginHelper} from '../helper/login.helper';
import {ActionHelper} from '../helper/action.helper';
import {MatDialog} from '@angular/material/dialog';

/** Attaches Authorization header to every request. */
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  private openPopupOnce = true;

  constructor(
    private readonly userTokenService: UserTokenService,
    private dialog: MatDialog
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.userTokenService.getToken();

    if (!!token) {
      request = request.clone({headers: request.headers.set(TOKEN_KEY, token)});
    } else {
      request = request.clone({headers: request.headers.delete(TOKEN_KEY)});
    }

    return next.handle(request).pipe(catchError((err: any) => {

        // logout user when user an authorized
        if (err.status === 401) {
          if (!localStorage.getItem('lastOpenedPath')) {
            localStorage.setItem('lastOpenedPath', window.location.pathname ? window.location.pathname : '/');
          }

          LoginHelper.logout(this.userTokenService);
          return undefined;
        }

        // show message in case of maintenance mode is true
        if(err.status === 503) {

          if (this.openPopupOnce) {
            this.openPopupOnce = false;
            ActionHelper.showAction('MAINTENANCE_MODE', this.dialog, {endDate : err.error.endDate} );
          }
          return undefined;
        }

        // show general message in case of rest errors
        if (err.status !== 400 && err.status !== 404) {
          if (this.openPopupOnce) {
            this.openPopupOnce = false;
            ActionHelper.showAction('GENERAL_ERROR', this.dialog);
          }
        }

        return throwError(err);
      })
    );
  }
}
